import en from './en-faq-data'
import hi from './hi-faq-data'
import fr from './fr-faq-data'
import es from './es-faq-data'
import ar from './ar-faq-data'
import pt from './pt-faq-data'
import ptbr from './pt-br-faq-data'
import ru from './ru-faq-data'
import de from './de-faq-data'
import vi from './vi-faq-data'
import te from './te-faq-data'
import ta from './ta-faq-data'
import kn from './kn-faq-data'
import or from './or-faq-data'

export type List = {
  name: string
  nameEn?: string
  code: string
  type: 'game' | 'tag'
}

type Body = {
  text: string[]
  list: List[]
}

export type Tag = 'h1' | 'h2' | 'h3'

export enum AccordionState {
  InitialOpen = 'initial_open',
  InitialClose = 'initial_close',
  AlwaysOpen = 'always_open',
}

export type TMetaData = {
  title: string
  desc: string
}

export type InitialState = 'initial_open' | 'initial_close' | 'always_open'

export type InfoEntry = {
  tag: Tag
  title: string
  body: Body
  initalState?: InitialState
  links?: DescLink
}

export type DescLink = {
  [key: string]: string | List
}

type TFaq = {
  tag: Tag
  title: string
  body: string[]
  links?: DescLink
}

export type TFaqSection = {
  headTag: Tag
  headTitle: string
  faqs: TFaq[]
}

type FAQLangEntry = {
  meta: TMetaData
  info: InfoEntry[]
  faq: TFaqSection
}

type FaqData = {
  en: FAQLangEntry
  hi: FAQLangEntry
  fr: FAQLangEntry
  es: FAQLangEntry
  ar: FAQLangEntry
  pt: FAQLangEntry
  ru: FAQLangEntry
  de: FAQLangEntry
  vi: FAQLangEntry
  te: FAQLangEntry
  ta: FAQLangEntry
  kn: FAQLangEntry
  or: FAQLangEntry
  'pt-br': FAQLangEntry
}

// en: English
// hi: Hindi
// es: Spanish
// fr: French
// ar: Arabic
// pt: Portuguese
// ru: Russian
// de: German
// te: Telugu
// ta: Tamil
// vi: Vietnamese
// kn: Kannada
// or: Odia (Oriya)

export const faqData: FaqData = {
  en,
  hi,
  fr,
  es,
  ar,
  pt,
  ru,
  de,
  vi,
  te,
  ta,
  kn,
  or,
  'pt-br': ptbr,
}
